import { Fragment, useEffect, useState } from "react";
import Loading from "../Loading";

const Print = () => {
  const [pdf, setPdf] = useState("");
  const [isLoader, setisLoader] = useState(false);

  useEffect(() => {
    if (pdf === "") {
      setPdf(localStorage.getItem("pdf"));
    }

    setisLoader(true);
    setTimeout(function () {
      setisLoader(false);
      window.print();
    }, 5000);
  }, [pdf]);

  return (
    <Fragment>
      {isLoader === true && <Loading />}

      <iframe
        type="application/pdf"
        id="printf"
        name="printf"
        src={pdf}
        style={{ width: "100%", height: "100vh" }}
      ></iframe>
    </Fragment>
  );
};

export default Print;
